var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10571_9260)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 5,
    r: 1,
    stroke: "#62626A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 9.42379C1.77774 9.36385 2.22704 9.33423 2.67711 9.33528C4.58106 9.29792 6.43839 9.8488 7.91767 10.8896C9.28962 11.8549 10.2536 13.1834 10.6666 14.6668",
    stroke: "#62626A",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.667C9.66667 11.0003 10.1181 10.8515 10.6667 10.667",
    stroke: "#62626A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.4758C12.4007 14.3337 10.9089 14.3337 7.99996 14.3337C5.0144 14.3337 3.52162 14.3337 2.59412 13.4062C1.66663 12.4787 1.66663 10.986 1.66663 8.0004C1.66663 5.09134 1.66663 3.59954 2.52463 2.66699",
    stroke: "#62626A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 10.667C13.6951 10.667 14.032 10.8633 14.2644 11.0429C14.3333 10.2465 14.3333 9.25532 14.3333 8.00033C14.3333 5.01476 14.3333 3.52198 13.4058 2.59449C12.4783 1.66699 10.9855 1.66699 7.99998 1.66699C6.39389 1.66699 5.2198 1.66699 4.33331 1.81138",
    stroke: "#62626A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 1.3335L14.6666 14.6668",
    stroke: "#62626A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10571_9260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorImage);
export default __webpack_public_path__ + "static/media/icon-error-image.5719aa5691646c498efe8e1eeb1f5968.svg";
export { ForwardRef as ReactComponent };